exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-46e3281f]{background-color:#506394!important;color:#fff}.container [data-v-46e3281f]{color:inherit}.step[data-v-46e3281f]{display:flex;margin-bottom:30px}.step-icon[data-v-46e3281f]{margin-right:30px}.step-icon img[data-v-46e3281f]{max-width:100px}.step-content h4[data-v-46e3281f]{font-size:20px;line-height:1.4;font-weight:700}.step-content a[data-v-46e3281f]{color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46e3281f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/register/steps.vue
// module id = m7Z6
// module chunks = 14